export enum DevRegions {
  TCTSA = 'TCTSA',
  TCTSC = 'TCTSC',
  TCTSI = 'TCTSI',
  TCTSJ = 'TCTSJ',
  TCTSR = 'TCTSR',
}
